/* Global header/footer behaviour for every page (v2). Mega menu, search,
   mobile drawer, footer fold + live cart count. Progressive enhancement only. */
(function(){
  if (!window.matchMedia || typeof document.querySelector !== 'function') return;
  var $ = function(s){ return document.querySelector(s); };
  var $$ = function(s){ return Array.prototype.slice.call(document.querySelectorAll(s)); };

  function panelFor(b){
    return document.getElementById(b.dataset.mmMega || b.dataset.mmSub);
  }
  function closeMegas(except){
    $$('[data-mm-mega],[data-mm-sub]').forEach(function(b){
      if (b !== except) {
        b.setAttribute('aria-expanded', 'false');
        var m = panelFor(b);
        if (m) m.classList.remove('mm-open');
      }
    });
  }

  var hoverOk = window.matchMedia && matchMedia('(hover:hover)').matches;

  try {
    $$('[data-mm-mega],[data-mm-sub]').forEach(function(b){
      var m = panelFor(b);
      if (!m) return;
      if (hoverOk){
        /* desktop: hover-only (never toggle via click, so panels can't stick open) */
        var t;
        var open = function(){ clearTimeout(t); closeMegas(b); b.setAttribute('aria-expanded', 'true'); m.classList.add('mm-open'); };
        var close = function(){ t = setTimeout(function(){ b.setAttribute('aria-expanded', 'false'); m.classList.remove('mm-open'); }, 180); };
        b.addEventListener('mouseenter', open);
        b.addEventListener('mouseleave', close);
        m.addEventListener('mouseenter', function(){ clearTimeout(t); });
        m.addEventListener('mouseleave', close);
      } else {
        /* touch: click toggle, first click in the already-open state closes */
        b.addEventListener('click', function(e){
          var already = b.getAttribute('aria-expanded') === 'true';
          closeMegas(b);
          b.setAttribute('aria-expanded', (!already).toString());
          m.classList.toggle('mm-open', !already);
          toggleSearch(false);
          e.stopPropagation();
        });
      }
    });
  } catch (e) {}

  function toggleSearch(on){
    var s = $('#mm-search'), btn = $('#mm-sbtn');
    if (!s || !btn) return;
    on = (on === undefined) ? !s.classList.contains('mm-open') : on;
    s.classList.toggle('mm-open', on);
    btn.setAttribute('aria-expanded', on.toString());
    if (on) { closeMegas(); var q = $('#mm-q'); if (q) q.focus(); }
  }
  var sbtn = $('#mm-sbtn');
  if (sbtn) sbtn.addEventListener('click', function(){ toggleSearch(); });

  var drawerPairs = [];
  var seq = Array.prototype.slice.call(document.querySelectorAll('header.mm-site, .mm-drawer'));
  seq.forEach(function(el, i){
    if (el.classList && el.classList.contains('mm-drawer')) return;
    var bg = el.querySelector('.mm-burger');
    if (!bg) return;
    var drEl = null;
    for (var j = i + 1; j < seq.length; j++){
      if (seq[j].classList && seq[j].classList.contains('mm-drawer')){ drEl = seq[j]; break; }
    }
    if (!drEl) return;
    drawerPairs.push({bg: bg, drEl: drEl});
  });

  function pairFor(bg){
    for (var k = 0; k < drawerPairs.length; k++){
      if (drawerPairs[k].bg === bg) return drawerPairs[k];
    }
    var seq2 = Array.prototype.slice.call(document.querySelectorAll('header.mm-site, .mm-drawer'));
    var following = false;
    for (var n = 0; n < seq2.length; n++){
      var node = seq2[n];
      if (node.classList && node.classList.contains('mm-drawer')){
        if (following) return {bg: bg, drEl: node};
      } else if (node === bg || (node.contains && node.contains(bg))){
        following = true;
      }
    }
    return null;
  }
  function openDrawer(pair, on){
    pair.drEl.classList.toggle('mm-open', on);
    pair.drEl.setAttribute('aria-hidden', (!on).toString());
    pair.bg.setAttribute('aria-expanded', on.toString());
    var anyOpen = drawerPairs.some(function(p){ return p.drEl.classList.contains('mm-open'); });
    document.body.style.overflow = anyOpen ? 'hidden' : '';
    if (on){ var closeBtn = pair.drEl.querySelector('[data-mm-close].mm-tool'); if (closeBtn) closeBtn.focus(); }
    else pair.bg.focus();
  }

  document.addEventListener('click', function(e){
    var bg = e.target.closest('button.mm-burger');
    if (bg){
      var p = pairFor(bg);
      if (p){
        var wasOpen = p.drEl.classList.contains('mm-open');
        openDrawer(p, !wasOpen);
        if (typeof window.MaaMitaharaLeadPopup !== 'undefined') MaaMitaharaLeadPopup.close();
      }
      return;
    }
    var closer = e.target.closest('[data-mm-close]');
    if (closer){
      var drEl = closer.closest('.mm-drawer');
      if (drEl) drawerPairs.forEach(function(p){ if (p.drEl === drEl) openDrawer(p, false); });
    }
  });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape'){
      closeMegas();
      toggleSearch(false);
      drawerPairs.forEach(function(p){ if (p.drEl.classList.contains('mm-open')) openDrawer(p, false); });
    }
  });
  document.addEventListener('click', function(e){
    if (!e.target.closest('header.mm-site')) closeMegas();
  });

  /* live cart count */
  function updateCartCount(){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){
        document.querySelectorAll('[data-mm-cart-count]').forEach(function(el){
          el.textContent = c.item_count;
          el.hidden = c.item_count === 0;
        });
        return c;
      })
      .catch(function(){});
  }

  /* footer link columns: folded on phones, permanently open on desktop.
     The <details> ship with open, so this only closes them once JS runs on a
     phone, and re-opens them if the viewport grows past the breakpoint. */
  var fMq = window.matchMedia('(max-width:860px)');
  function foldFooter(){
    document.querySelectorAll('footer.mm-site .mm-fcol details').forEach(function(d){ d.open = !fMq.matches; });
  }
  foldFooter();
  if (fMq.addEventListener) fMq.addEventListener('change', foldFooter);
  else if (fMq.addListener) fMq.addListener(foldFooter);

  updateCartCount();
  document.addEventListener('submit', function(e){
    var f = e.target;
    if (f && f.tagName === 'FORM') {
      var action = (f.getAttribute('action') || f.action || '').toString();
      if (action.indexOf('/cart/add') !== -1) setTimeout(updateCartCount, 1200);
    }
  });
})();